
import { onMounted, ref } from "vue";

export default {
    name: "App",
    setup() {
        return {};
    }
};
